module.exports = __webpack_public_path__ + "img/cloud3.48bdf250.png";